import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { ErrorsData } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';

const ERRORS = '/llm-admin/usage/errors';

export interface ErrorsParams {
  limit?: number;
  feature_id?: string;
  provider?: string;
}

const cleanParams = (params: ErrorsParams): Record<string, string> =>
  Object.entries(params).reduce<Record<string, string>>((acc, [k, v]) => {
    if (v !== undefined && v !== null && v !== '') acc[k] = String(v);
    return acc;
  }, {});

const useErrorsFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (params: ErrorsParams): Promise<ErrorsData> => {
    const qs = new URLSearchParams(cleanParams(params)).toString();
    const raw = await request<any>(qs ? `${ERRORS}?${qs}` : ERRORS);
    return unwrapEnvelope<ErrorsData>(raw);
  }, 'Failed to load LLM error log');
};

export const useErrorsQuery = (params: ErrorsParams = {}, enabled = true) => {
  const queryFn = useErrorsFn();
  return useQuery({
    queryKey: aiKeys.errors(params),
    queryFn: () => queryFn(params),
    enabled,
    staleTime: 1000 * 30,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
